<div fxLayout="column">
    <div class="container-login" fxLayout="row" fxLayoutAlign="center">
        <div [ngClass]="{'shake': shakeIt, 'card': true}">
            <h4 class="card-header" fxLayoutAlign="center"><img width="300" src="{{url}}assets/images/sunshine-logo.svg" alt="">
            </h4>
            <div class="card-body">
                <form name="loginForm" [formGroup]="authForm" (ngSubmit)="login()">
                    <div class="form-group">
                        <input type="email" class="form-control form-control-lg" placeholder="Email"
                            formControlName="email">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control form-control-lg" placeholder="Password"
                            formControlName="password">
                    </div>
                    <button type="submit" class="btn sign-btn"
                        [ngClass]="{'red' : buttonError, 'green': !buttonError}">{{isLoading ? buttonLog: 'Sign in'
                        }}</button>
                </form>
                <div class="forgot-link" fxLayoutAlign="center center">
                    <a href="" [routerLink]="['/login-forgot']">Forgot Password?</a>
                </div>                          
            </div>
            <div class="trouble-loging-info">
                <div>
                    <span class="trouble-login-icon"><i class="fas fa-question"></i>&nbsp;</span>
                    <span style="font-weight: bold;color:#659E71;">&nbsp;Need Support?</span>
                    <span style="color:#364245;">&nbsp;Contact Us at&nbsp;</span>
                    <a href="mailto:edproducts@sunshinecottage.org">edproducts@sunshinecottage.org</a>
                </div>              
            </div>
        </div>
    </div>
</div>